import FetchClient, { type ApiResponse } from "./FetchClient";

export interface KeywordSearch {
  id: string;
  keyword: string;
  retailers: string[];
  frequencyHours: number;
  enabled: boolean;
  /** Id of an admin-managed Discord webhook to notify on deep-discount hits (≥70% off). Empty/absent = no notifications. */
  notifyDiscordWebhookId?: string;
  lastRunAt?: number;
  createdAt?: number;
}

export interface KeywordSearchList {
  searches: KeywordSearch[];
  /** Every retailer selectable in the UI. */
  supportedRetailers: string[];
  /** Subset the master caller can actually search today. */
  implementedRetailers: string[];
}

export interface KeywordSearchInput {
  keyword: string;
  retailers: string[];
  frequencyHours: number;
  enabled: boolean;
  notifyDiscordWebhookId?: string;
}

export async function getKeywordSearches(): Promise<KeywordSearchList> {
  const response = await FetchClient.get<ApiResponse<KeywordSearchList>>("/admin/keyword-searches");
  return response.data;
}

export async function createKeywordSearch(data: KeywordSearchInput): Promise<KeywordSearch> {
  const response = await FetchClient.post<ApiResponse<KeywordSearch>>("/admin/keyword-searches", data);
  return response.data;
}

export async function updateKeywordSearch(id: string, data: KeywordSearchInput): Promise<KeywordSearch> {
  const response = await FetchClient.patch<ApiResponse<KeywordSearch>>(`/admin/keyword-searches/${encodeURIComponent(id)}`, data);
  return response.data;
}

export async function deleteKeywordSearch(id: string): Promise<void> {
  await FetchClient.delete(`/admin/keyword-searches/${encodeURIComponent(id)}`);
}
